<div class="main-header">
  <div class="logo">
    <a href="" [routerLink]="['dashboard/v5']">
      <img src="./assets/images/logo.png" alt="" />
    </a>
  </div>

  <!-- <div class="menu-toggle" (click)="toggelSidebar()">
   
    [ngClass]="navService.sidebarState.sidenavOpen ? '' : 'open'"

  </div> -->

  <!-- Hamburger menu -->

  <div class="icon nav-icon-3" [ngClass]="navService.sidebarState.sidenavOpen ? '' : 'open'" (click)="toggelSidebar()">
    <span></span>
    <span></span>
    <span></span>
  </div>
  
  <!-- Hamburger menu end -->

  <div class="d-flex align-items-center">
    <div class="alert-box" *ngIf="isShow">
      <span class="alert-text">Uyarı:</span>
      <span class="alert-message">{{showMessage}}</span>
      <button class="payment-button" (click)="makePayment()">Ödeme Yap</button>
    </div>
    <!-- Mega menu -->
    <!-- <div ngbDropdown class="mega-menu d-none d-md-block">
            <button ngbDropdownToggle href="#" class="btn text-muted dropdown-toggle mr-3">Mega Menu</button>
            <div ngbDropdownMenu perfectScrollbar>
                <div class="row m-0">
                    <div class="col-md-4 p-4 bg-img">
                        <h2 class="title">Mega Menu <br> Sidebar</h2>
                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Asperiores natus
                            laboriosam fugit, consequatur.
                        </p>
                        <p class="mb-4">Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                            Exercitationem odio amet eos dolore suscipit placeat.</p>
                        <button class="btn btn-lg btn-rounded btn-outline-warning">Learn More</button>
                    </div>
                    <div class="col-md-4 p-4">
                        <p class="text-primary text--cap border-bottom-primary d-inline-block">Features</p>
                        <div class="menu-icon-grid w-auto p-0">
                            <a href="#"><i class="i-Shop-4"></i> Home</a>
                            <a href="#"><i class="i-Library"></i> UI Kits</a>
                            <a href="#"><i class="i-Drop"></i> Apps</a>
                            <a href="#"><i class="i-File-Clipboard-File--Text"></i> Forms</a>
                            <a href="#"><i class="i-Checked-User"></i> Sessions</a>
                            <a href="#"><i class="i-Ambulance"></i> Support</a>
                        </div>
                    </div>
                    <div class="col-md-4 p-4">
                        <p class="text-primary text--cap border-bottom-primary d-inline-block">Components</p>
                        <ul class="links">
                            <li><a href="accordion.html">Accordion</a></li>
                            <li><a href="alerts.html">Alerts</a></li>
                            <li><a href="buttons.html">Buttons</a></li>
                            <li><a href="badges.html">Badges</a></li>
                            <li><a href="carousel.html">Carousels</a></li>
                            <li><a href="lists.html">Lists</a></li>
                            <li><a href="popover.html">Popover</a></li>
                            <li><a href="tables.html">Tables</a></li>
                            <li><a href="datatables.html">Datatables</a></li>
                            <li><a href="modals.html">Modals</a></li>
                            <li><a href="nouislider.html">Sliders</a></li>
                            <li><a href="tabs.html">Tabs</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
    <!-- Search bar -->
    <!-- <div class="search-bar">
            <input type="text" placeholder="Search" (focus)="searchService.searchOpen = true">
            <i class="search-icon text-muted i-Magnifi-Glass1"></i>
        </div> -->
  </div>

  <div style="margin: auto"></div>

  <div class="header-part-right">

    
  <span class="material-symbols-outlined clrblck sun-icon">light_mode</span>
  <mat-slide-toggle [checked]="isDarkMode" (change)="toggleFilterTheme($event)" labelPosition="after">
  <span class="material-symbols-outlined clrblck moon-icon">dark_mode</span>
  </mat-slide-toggle>
    
  <mat-menu #downloadMenu="matMenu">
    <button mat-menu-item (click)="downloadFile('file1')">{{"PrintApp" | localize}}</button>
    <button mat-menu-item (click)="downloadFile2('file2')">{{"AndroidApp" | localize}}</button>
  </mat-menu>
  
  <button class="clrblck" mat-icon-button [matMenuTriggerFor]="downloadMenu">
    <mat-icon>download</mat-icon>
  </button>

    <div ngbDropdown [placement]="'bottom-right'">
      <div class="badge-top-container">
        <i
          ngbDropdownToggle
          class="imind-user header-icon d-none d-sm-inline-block eight " tourAnchor="8"
          role="button"
          #dropdown
        ></i>
      </div>
      <div
        ngbDropdownMenu
        class="notification-dropdown rtl-ps-none"
        [perfectScrollbar]
      >
        <ng-container *ngIf="notifications.length > 0">
          <p class="h-100 bcgray onusers cnt">{{ "OnlineUsers" | localize }}</p>
          <!-- [routerLink]="[item.link]" -->
          <div
            class="dropdown-item d-block h-100"
            *ngFor="let user of onlineUsers"
          >
            <img
              class="notification-icon mt2"
              src="./assets/images/faces/road_worker_background.png"
              id="onlineUser"
              style="margin: 2%"
              ngbDropdownToggle
              alt=""
            />
            <div class="notification-details flex-grow-1">
              <p class="m-0 d-flex align-items-center">
                <span>{{ getTypedUserName(user) }}</span>
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <i
      fullScreenWindow
      class="imind-full-screen header-icon d-none d-sm-inline-block"
      role="button"
    ></i>
    <!-- <div ngbDropdown [placement]="'bottom-right'" class="d-none d-sm-inline-block">
            <i ngbDropdownToggle class="i-Gear text-muted header-icon" role="button"></i>
            <div ngbDropdownMenu class="menu-icon-grid-dropdown">
                <div class="menu-icon-grid">
                    <a href="#"><i class="imind-shop-4"></i> Home</a>
                    <a href="#"><i class="imind-library"></i> UI Kits</a>
                    <a href="#"><i class="imind-drop"></i> Apps</a>
                    <a href="#"><i class="imind-file-clipboardfiletext"></i> Forms</a>
                    <a href="#"><i class="imind-checked-user"></i> Sessions</a>
                    <a href="#"><i class="imind-ambulance"></i> Support</a>
                </div>
            </div>
        </div> -->

    <div
      ngbDropdown
      [placement]="'bottom-right'"
      (openChange)="checkDropDown($event)"
    >
      <div class="badge-top-container">
        <span class="badge badge-primary" *ngIf="unreadNotificationCount > 0">{{
          unreadNotificationCount
        }}</span>

        <i
          ngbDropdownToggle
          class="imind-bell-2 header-icon d-none d-sm-inline-block" tourAnchor="7"
          role="button"
          #dropdown
        ></i>
        
      </div>
      <div
        ngbDropdownMenu
        class="notification-dropdown rtl-ps-none w350"
        [ngStyle]="{
          'max-height': notifications.length > 0 ? 'inherit' : '20px'
        }"
        [ngClass]="{'ddm1': notifications.length == 0 }"
      >
        <ng-container *ngIf="notifications.length > 0; else elseContent">
          <p class="mt-2 text-center font-weight-bold bcgray notifications"> 
            {{ "Notifications" | localize }}
          </p>
          <!-- [routerLink]="[item.link]" -->
          <div
            class="dropdown-item d-block custom h-100"
            *ngFor="let item of notifications"
            (click)="markAsRead(item)"
          >

            <div class="notification-details flex-grow-1">
                <div class="col-lg-8 col-sm-8 col-8 mw90 ml10 tal"
                >
                  <span *ngIf="item.fresh" class="badge badge-info">{{
                  "New" | localize
                }}</span>
                <span *ngIf="item.fresh" class="pr0">
                  &nbsp;</span
                >
                <i
                ngbDropdownToggle
                class="imind-bell-2 header-icon d-none d-sm-inline-block noticon"
                role="button">
                </i>
                  <strong><span>{{ getTitle(item.type) }}</span></strong>
                <div class="wsi">
                  {{ item.message }}
                </div>
                <span>{{ item.time | date: "medium" }}</span>
                </div>
            </div>
          </div>
          <div class="pagipagi">
          <div class="pagination">
            <ngb-pagination
              class="pagination justify-content-center custom-pagination"
              [(page)]="pageIndex"
              [pageSize]="pageSize"
              [collectionSize]=40
              (pageChange)="pageChangeEvent($event)"
            ></ngb-pagination>
          </div>
          </div>
        </ng-container>
        <ng-template #elseContent class="notification-details flex-grow-1">
          {{ "ZeroNotification" | localize }}
        </ng-template>
      </div>
    </div>
    <div
      ngbDropdown
      [placement]="'bottom-right'"
      class="user col align-self-end"
    >
      <img
        src="./assets/images/faces/road_worker_background.png"
        id="userDropdown"
        ngbDropdownToggle
        alt=""
      />

      <div
        ngbDropdownMenu
        aria-labelledby="userDropdown"
        class="header-account-dropdown dropdownmenu1"
      >
        <span class="dropdown-item"
          class="btn btn-1 userbutton fontSize"
          *ngIf="currentUser != null"
          >
          <img
          src="./assets/images/faces/road_worker_background.png"
          id="userDropdown"
          class="userlogo"
        />{{ currentUser.user.name }} {{ currentUser.user.surname }}</span
        >
        <button class="dropdown-item pt6 pd5 iconFlexed fontSize"
        (click)="onSetDefaults()">
        <span class="material-icons">tune</span>
          {{ "FixedValues" | localize }}
        </button>
        <button class="dropdown-item pd5 iconFlexed fontSize" (click)="changePassword()">
          <span class="material-icons">lock_reset</span>
          {{ "UpdatePassword" | localize }}
        </button>
        <button class="dropdown-item pd5 iconFlexed fontSize" (click)="onSetLanguage()">
          <span class="material-icons"> language </span>
          {{ "ChangeLanguage" | localize }}
        </button>
        <button
          class="logOut iconFlexed pd5 fontSize LogoutHover"
          (click)="signout()"  
        >
        <span class="material-icons">
          logout
          </span>
          {{ "Out" | localize }}
        </button>
      </div>
    </div>
  </div>
  <tour-step-template></tour-step-template>
</div>
